import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import BaseActionForm from '../BaseActionForm';
import { Button } from "react-bootstrap";
import './styles.scss'

import LeftPanelHeader from './../../components/LeftPanelHeader';
import * as actionTypes from "../../services/StoreContainer/actionTypes";

export default function MassUpdate(props) {
    const dispatch = useDispatch();
    const datasetsContainer = useSelector((store) => { return store.datasetsReducer })

    return <MassUpdateClass
        {...props}
        dispatch={dispatch}
        datasetsContainer={datasetsContainer}
    />
}

class MassUpdateClass extends BaseActionForm {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            runningOperation: null,
            completeMessage: null,
            newValue: null
        }
    }

    async componentDidMount() {
        super.componentDidMount();

        let dataset = this.props.datasetsContainer.selectedDataset;
        this.setState({ dataset: dataset });
    }

    updatingManyColumns = (value) => {
        this.setState({ runningOperation: true });

        let setFields = {
            [this.props.field]: value
        }

        let filters = this.props.filters || {};
        let multiStageField = this.props.field.split('.');
        if (multiStageField.length > 1) {
            for (let i = 1; i < multiStageField.length; i++) {
                let partField = multiStageField.slice(0, i).join('.');
                filters[partField] = { '$ne': null }
            }
        }

        let body = {
            "filter": filters,
            "set": setFields,
            "timeFieldsNames": [] //TODO: когда появятся поля типа даты, надо будет добавить логику по заполнению этого параметра
        }

        this.lkApi.updateManyObjects(
            body,
            "userDatasetByToken",
            this.props.token
        ).then((response) => {
            if (response.modifiedCount) {
                this.setState({
                    runningOperation: false,
                    completeMessage: 'Готово! Обновлено ' + response.modifiedCount + ' записей.'
                });
            }
            else {
                this.setState({
                    runningOperation: false,
                    completeMessage: 'Не удалось, попробуйте еще раз.'
                });
            }
        });
    }

    render() {
        let filterLabels = [];
        if (this.state.dataset && this.props.filters && (Object.entries(this.props.filters).length > 0)) {
            Object.entries(this.props.filters).forEach((fieldName) => {
                this.state.dataset.fields.forEach((field) => {
                    if (field.name === fieldName[0]) {
                        filterLabels.push("поле «" + field.caption + "»: значение «" +
                            (
                                this.props.filters[fieldName[0]] && this.props.filters[fieldName[0]]['$regex'] ?
                                    this.props.filters[fieldName[0]]['$regex'] :
                                    (document.getElementById(`text-filter-column-${fieldName[0]}`).value)
                            )
                            + "»");
                    }
                });
            });
        }

        let fieldCaption = "";
        this.state.dataset && this.state.dataset.fields.forEach((field) => {
            if (field.name === this.props.field) {
                fieldCaption = field.caption;
            }
        });
        return (
            <div className='twoHalfs'>
                <div id={"MassUpdate"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <LeftPanelHeader
                        dataset={this.state.dataset}
                        sectionName={this.sectionName(actionTypes.MASS_UPDATE)}
                    />

                    <div className="postHeaderContainer textRoboto infoContainer">

                        {(filterLabels.length > 0) ?
                            <div>
                                <p className="textHint">Изменения применятся к {this.props.count} записям, поскольку выбраны фильтры:</p>
                                {filterLabels.map((label, i) => (
                                    <p className="textHint" key={'textHintMap' + i}>- {label}</p>
                                ))}
                            </div>
                            :
                            <p className="textHint">Изменения будут применяться ко всему набору. Если нужно, выберите фильтрами колонок какую-то часть данных.</p>
                        }

                        <p className="textBottom">Задайте значение полю «{fieldCaption}»</p>

                        {(!this.state.completeMessage) && (!this.state.runningOperation) &&
                            <>
                                <input
                                    className={'valueField'}
                                    type={'text'}
                                    onChange={(e) => {
                                        this.setState({ newValue: e.target.value });
                                    }}
                                />
                            </>
                        }

                        {(this.state.runningOperation) &&
                            <p className="textBottom" key='textBottom1'>Процесс начался...</p>
                        }

                        {(this.state.completeMessage) &&
                            <p className="textBottom">{this.state.completeMessage}</p>
                        }
                    </div>
                    {(!this.state.completeMessage) && (!this.state.runningOperation) &&
                        <><Button
                            className='applyInstrument blueBtn'
                            onClick={() => {
                                this.updatingManyColumns(null);
                            }}
                        >Обнулить</Button>
                            <Button
                                className='applyInstrument'
                                style={this.state.newValue ? { opacity: '1' } : { opacity: '0.3', pointerEvents: 'none' }}
                                onClick={() => {
                                    this.updatingManyColumns(this.state.newValue);
                                }}
                            >Заполнить</Button>
                        </>}
                </div>

                <div className='rightHalf'></div>
            </div>
        );
    }
}

